
export enum TrackingCategory {
    DEPOT_REQUETE = 'Dépot de requête',
    DEPOT_REQUETE_COMPTE = 'Dépot de requête par type de compte',
    DEPOT_REQUETE_TYPE = 'Dépot de requête par type',
    DEPOT_REQUETE_TYPE_JURIDICTION = 'Dépot de requête par type de juridiction',
    DEPOT_REQUETE_SITE_JURIDICTION = 'Dépot de requête par site juridiction',
    DEPOT_REQUETE_URGENCE = 'Dépot de requête par urgence',
    RATACHEMENT = 'Rattachement',
    AJOUT_DOCUMENTS = 'Ajout de documents',
    CONSULTATION_DOSSIER = 'Consultation de dossier',
    AUTHENTICATION = 'Authentication',
    FOOTER = 'Footer',
    HEADER = 'Header',
    MES_DOSSIER = 'Mes dossiers'
}

export enum TrackingAction {
    SUCCESS = 'Réussi',
    FAILED = 'Échoué',
    DOWNLOAD = 'Téléchargement',
    DOWNLOAD_FAILED = 'Téléchargement - Échoué',
    OPTION_ACTIVATED = 'Option activée',
    OPTION_NOT_ACTIVATED = 'Option non activée',
    CLIQUER = 'Cliquer'
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/model/tracking/tracking.enum.ts